<template>
    <div class="menu fixed pin-l w-full mx-auto px-6 pt-2 bg-white z-30 shadow">
        <div class="container py-4">
            <ul class="list-reset flex">
            <li class="text-center flex-1 text-blue-dark text-xs">
                {{total}} {{$t('all.total')}}
            </li>
            <li class="text-center flex-1 pl-2">
              <slot name="left"></slot>
            </li>
            <li class="text-center flex-1">
                <slot name="right"></slot>
            </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            total: {
                type: Number,
                default: 0,
            },
        },
    };
</script>
